import {ssrSafeWindow} from '@github-ui/ssr-utils'
import {
  BASE_DIFF_MARGIN_TOP_PADDING,
  MINI_HEADER_HEIGHT,
  STICKY_HEADER_HEIGHT,
} from '@github-ui/pull-requests/constants'

/**
 * Scrolls to an element while accounting for the sticky header height
 * @param element - The HTML element to scroll to
 * @param addMiniHeaderHeight - Whether to add the mini header height to the offset
 */
export function scrollToElementWithOffset(
  element: HTMLElement | null | undefined,
  addMiniHeaderHeight?: boolean,
): void {
  if (!element || !ssrSafeWindow) return

  const scrollY = ssrSafeWindow.scrollY ?? 0
  const stickyHeight = STICKY_HEADER_HEIGHT + (addMiniHeaderHeight ? MINI_HEADER_HEIGHT : 0)
  const yOffset = element.getBoundingClientRect().top + scrollY - BASE_DIFF_MARGIN_TOP_PADDING - stickyHeight

  ssrSafeWindow.scrollTo({top: yOffset, left: 0})

  // Focus the appropriate element for keyboard navigation
  element.focus()
}
